import { Theme } from '@material-ui/core';

import { generateSemanticColorStyles } from '../utils';

export const tiptapBlockMarginTop = 'var(--encore-spacing-tighter-2)';
export const tiptapBlockMarginBottom =
  'var(--tiptap-block-margin-bottom, var(--encore-spacing-looser))';
export const tiptapTextPadding = 'var(--encore-spacing-tighter-4) 0';

export const getEditorStyles = (theme: Theme) => ({
  position: 'relative' as const,
  maxWidth: '92ch',
  ...generateSemanticColorStyles(theme.palette.type === 'dark'),
  '& > .ProseMirror': {
    outline: 'none',
  },
  '& .ProseMirror-dropcursor': {
    border: 'none',
  },
  '& .editor-paragraph': {
    cursor: 'text',
  },
  '& .editor-paragraph.is-empty::before': {
    color: 'var(--essential-subdued)',
    content: 'attr(data-placeholder)',
    float: 'left' as const,
    height: 0,
    pointerEvents: 'none' as const,
  },
  '& .caption': {
    fontFamily: 'var(--encore-body-font-stack)',
    fontSize: 'var(--encore-text-size-smaller-2)',
    lineHeight: 1.4,
    color: 'var(--text-subdued)',
    fontWeight: 700,
    letterSpacing: '0.5px',
    margin: 0,
    padding: tiptapTextPadding,
    cursor: 'text',
  },
  '& p.is-editor-empty::before': {
    color: 'var(--essential-subdued)',
    content: 'attr(data-placeholder)',
    float: 'left' as const,
    height: 0,
    pointerEvents: 'none' as const,
  },
  '& [data-type="callout-block"]': {
    marginTop: tiptapBlockMarginTop,
    marginBottom: tiptapBlockMarginBottom,
  },
  '& .editor-columns': {
    display: 'flex',
    margin: 0,
    marginBottom: tiptapBlockMarginBottom,
    marginTop: tiptapBlockMarginTop,
    width: '100%',
  },
  '& .editor-column': {
    flex: '1 1 0%',
    minWidth: 0,
    margin: 0,
    borderRight: '1px solid transparent',
    paddingRight: 'var(--encore-spacing-tighter-2)',
    paddingLeft: 'var(--encore-spacing-tighter-2)',
    transition: 'border-color 0.1s ease-in-out',
    '& .editor-paragraph': {
      position: 'relative' as const,
    },
    '& .editor-paragraph.is-empty::before': {
      float: 'none' as const,
      height: 'auto',
      position: 'absolute' as const,
      left: 0,
      right: 0,
      whiteSpace: 'nowrap' as const,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '&:first-child': {
      paddingLeft: 0,
    },
    '&:last-child': {
      borderRight: 'none',
      paddingRight: 0,
    },
    '& > :last-child': {
      '--tiptap-block-margin-bottom': tiptapBlockMarginTop,
    },
  },
  '& .editor-columns:hover .editor-column:not(:last-child)': {
    borderRight: '1px solid var(--decorative-subdued)',
  },
  '& .editor-column--focused:not(:last-child)': {
    borderRight: '1px solid var(--decorative-subdued)',

    '& > *:last-child': {
      marginBottom: 0,
    },
  },
  '& table': {
    tableLayout: 'fixed' as const,
    width: '100%',
    minWidth: '600px',

    '& .selectedCell': {
      position: 'relative' as const,

      '&:after': {
        zIndex: 2,
        position: 'absolute' as const,
        content: '""',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: 'var(--background-tinted-press)',
        pointerEvents: 'none' as const,
      },
    },

    '& td .editor-paragraph.is-empty::before, & th .editor-paragraph.is-empty::before':
      {
        float: 'none' as const,
        height: 'auto',
        position: 'absolute' as const,
        left: 'var(--encore-spacing-tighter-2)',
        right: 'var(--encore-spacing-tighter-2)',
        whiteSpace: 'nowrap' as const,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },

    '& .column-resize-handle': {
      position: 'absolute' as const,
      right: -8,
      top: 0,
      bottom: -2,
      width: 16,
      background: 'transparent',
      cursor: 'col-resize',

      '&::after': {
        content: '""',
        position: 'absolute' as const,
        left: 7,
        top: 0,
        bottom: 0,
        width: 2,
        backgroundColor: 'transparent',
        transition: 'background-color 0.15s',
      },

      '&:hover::after': {
        backgroundColor: 'var(--essential-base)',
      },
    },
  },
  '& .tiptap-comment-highlight': {
    backgroundColor: 'rgba(255, 223, 0, 0.3)',
    cursor: 'pointer',
    borderBottom: '2px solid var(--essential-warning)',
    '&:hover': {
      backgroundColor: 'rgba(255, 223, 0, 0.5)',
    },
  },
});
